export const NODE_ENV = import.meta.env.MODE || "development";
export const DATABASE_NAME =
	import.meta.env.VITE_INDEXEDDB_NAME || "HOOPOE_DATABASE";
